import ActivityView from './ActivityView'
import React from 'react'

const Activity: React.FunctionComponent = () => <ActivityView />

export default Activity
